import tw, { css, styled } from "twin.macro"

export const SearchResultsWrapper = styled.div`
  ${({ gridView }) => css`
    .search-results {
      grid-template-columns: repeat(1, 1fr) !important;
      gap: 1.5rem !important;
      padding: 0 .625rem;

      @media only screen and (min-width: 640px) and (max-width: 768.98px) {
        grid-template-columns: repeat(2, minmax(0px, 1fr)) !important;
      }
      
      @media only screen and (min-width: 768.99px) {
        grid-template-columns: ${gridView ? 'repeat(4, minmax(0px, 1fr))' : 'repeat(2, minmax(0px, 1fr))'} !important;
        gap: 3rem !important;
      }
    }
  `}
`

export const Grid = styled.div`
  ${tw`grid grid-cols-2 md:grid-cols-4 gap-1`}
`
